import { render, staticRenderFns } from "./SoldSoferi.vue?vue&type=template&id=8b7bca6e&scoped=true&"
import script from "./SoldSoferi.vue?vue&type=script&lang=js&"
export * from "./SoldSoferi.vue?vue&type=script&lang=js&"
import style0 from "./SoldSoferi.vue?vue&type=style&index=0&id=8b7bca6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7bca6e",
  null
  
)

export default component.exports